import { jdiColorFetch } from '../colorFetchV2';
import { SwitchRequest, FetchResponse } from './root.interface';

/**
 * 用户个性化推荐开关设置
 * @param requestData
 * @returns
 */
export const getOrSetSwitches = async (requestData: SwitchRequest): Promise<FetchResponse> => {
  const res = await jdiColorFetch(`user_settings_getOrSetSwitches`, {
    method: 'post',
    bodyQuery: requestData,
  });
  return res;
};
